import { action } from 'satcheljs/lib/legacy';
import sendTxpUserSettingsAction from '../utils/sendTxpUserSettingsAction';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';

export default action('reloadTxpSettings')(async function reloadTxpSettings(
    shouldLogDatapoint?: boolean,
    entryPoint?: TxpSettingsEntryPoint
) {
    sendTxpUserSettingsAction(shouldLogDatapoint, entryPoint);
});
